import { render, staticRenderFns } from "./viewSceneStandardMake.vue?vue&type=template&id=410b71b0&scoped=true&"
import script from "./viewSceneStandardMake.vue?vue&type=script&lang=js&"
export * from "./viewSceneStandardMake.vue?vue&type=script&lang=js&"
import style0 from "./viewSceneStandardMake.vue?vue&type=style&index=0&id=410b71b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b71b0",
  null
  
)

export default component.exports